/// <reference path="../../typings/browser.d.ts" />

namespace Application.Models {
    'use strict';

    export interface IMultiBlock {
        name: string;
        leftBlock: IBlock;
        rightBlock: IBlock;
        origBlockConnection: IBlockConnection;
        destBlockConnection: IBlockConnection;
        href: string;
    }

    export interface INewMultiBlock {
        name: string;
        origBlockConnectionId: number;
        destBlockConnectionId: number;
    }

    export class MultiBlock implements IMultiBlock {

        public static allowedConnections: string[] = ['ASI', 'SDI'];

        public href: string;
        public name: string;
        public leftBlock: IBlock;
        public rightBlock: IBlock;
        public origBlockConnection: IBlockConnection;
        public destBlockConnection: IBlockConnection;

        public static areCompatibleBlocks(from: Block[], to: Block[]): boolean {
            for (let b1 of from) {
                for (let b1Connection of b1.blockConnections) {
                    for (let b2 of to) {
                        for (let b2Connection of b2.blockConnections) {
                            if (b1Connection.direction === 'OUTPUT' && b2Connection.direction === 'INPUT' &&
                                b1Connection.connectionTypeName === b2Connection.connectionTypeName &&
                                Common.Utils.isInArray(b1Connection.connectionTypeName, Models.MultiBlock.allowedConnections)) {
                                return true;
                            }
                        }
                    }
                }
            }
            return false;
        }

        public static Empty(): MultiBlock {
            return new MultiBlock();
        }

        constructor() {
            // empty constructor
        }

        public class(): TopologyElementType {
            return TopologyElementType.MultiBlock;
        }

        public getDisplayImage(): string {
            return 'images/iconmonstr-link-6-240.png';
        }
    }
}